import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Header, SearchBars, Sides, Tabbles } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { PiBinoculars, PiScrollLight } from "react-icons/pi";
import { BsEye } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { t } from "i18next";
import { Link } from "react-router-dom";

const ListOfInvoice = ({ loginData }) => {
    const dispatch = useDispatch();
    const [dateRange, setDateRange] = useState([null, null]);
    const [options, setOptions] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");
    const [search, setSearch] = useState("");
    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };

    useEffect(() => {
        dispatch(actionDoctor.getClinicDoctor(loginData.userGuid));
    }, [dispatch, loginData]);
    const getClinicDoctorData = useSelector(
        (state) => state.doctor.getClinicDoctorData?.data
    );
    useEffect(() => {
        if (getClinicDoctorData) {
            const newOption = getClinicDoctorData?.result?.map((item) => ({
                value: item.clinicGuid,
                label: item.clinicName,
            }));
            setOptions(newOption);
        }
    }, [getClinicDoctorData]);
    const handleChange = (type, value) => {
        switch (type) {
            case "search":
                setSearch(value);
                break;
            case "clinic":
                setSelectedClinic(value);
                break;
            default:
                break;
        }
    };
    const onSearchClick = () => { };
    useEffect(() => {
        dispatch(
            actionDoctor.getAllInvoiceDoctorById(
                loginData.clinicGuid,
                loginData.userGuid
            )
        );
    }, [dispatch, loginData.clinicGuid, loginData.userGuid]);
    const getAllInvoiceDoctorByIdData = useSelector(
        (state) => state.doctor.getAllInvoiceDoctorByIdData?.data
    );
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage pageHeading={t("list_of_invoices")} />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <SearchBars.SearchBar
                        className="search-bar"
                        cDateRangeClassname="custom-date-range-picker"
                        select2Classname="select3"
                        searchGrpClassName="form-group1"
                        buttonClassname="btn-solid-Aqua_Teal"
                        showDate={true}
                        showSelect2={true}
                        datepickermd={3}
                        selectColmd2={4}
                        searchColmd={3}
                        buttonColmd={2}

                        datepickerlg={3}
                        selectCollg2={3}
                        searchCollg={5}
                        buttonCollg={1}

                        cDateRangePlaceholder={t("select_date")}
                        select2Placeholder={`${t("Select")}  ${t("Clinic")}`}
                        searchPlaceholder={t("Search")}
                        dateRange={dateRange}
                        select2Value={selectedClinic}
                        searchValue={search}
                        select2Options={options}
                        onDateRangeChange={handleDateRangeChange}
                        onClinicChange={(selected) => handleChange("clinic", selected)}
                        onSearchChange={(e) => handleChange("search", e.target.value)}
                        buttonChildren={<PiBinoculars className="bionCularIcon" />}
                        onSearchClick={onSearchClick}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<PiScrollLight className="header-Icn" />}
                        heading={t("Invoices")}
                        columns={[
                            `${t("booking_id")}`,
                            `${t("invoice_no")}`,
                            `${t("doctors_name")}`,
                            `${t("patient_name")}`,
                            `${t("time_&_date")}`,
                            loginData?.currencyCode,
                            `${t("View")}`,
                        ]}
                        data={getAllInvoiceDoctorByIdData?.result?.map((loi) => ({
                            [t("booking_id")]: loi.bookingId,
                            [t("invoice_no")]: loi.invoiceNumber,
                            [t("doctors_name")]: loi.doctorName,
                            [t("patient_name")]: loi.patientName,
                            [t("time_&_date")]: (
                                <>
                                    <div>
                                        {new Date(loi.appointmentDate).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </div>
                                    <div>
                                        {new Date(loi.appointmentDate)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, " - ")}
                                    </div>
                                </>
                            ),
                            [loginData?.currencyCode]: loi.consultFees,
                            [t("View")]: loi.pdfUrl ? (
                                <div className="editBlkIcon">
                                    <Link to={loi.pdfUrl} target="_blank" className="view-link">
                                        <BsEye className="editIcon" />
                                    </Link>
                                </div>
                            ) : null,
                        }))}
                        tabbleClassname="tabble"
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default ListOfInvoice;
